// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'micro-arrow-right';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M7 6.415v5.17c0 .31.147.517.265.362L9.89 9.362a.654.654 0 0 0 .059-.62c-.03-.052-.03-.104-.06-.104L7.266 6.053C7.147 5.898 7 6.104 7 6.415z'
  />
);

export const viewBox = '0 0 18 18';
